import React, { Component } from 'react';

import App from './Components/App';
import VerifyUser from './Components/VerifyUser.js';
import ResetPassword from './Components/ResetPassword';
import FourZeroFour from './Components/FourZeroFour';
import FourZeroThree from './Components/FourZeroThree';

import {BrowserRouter, Route, Switch} from "react-router-dom";

class Router extends Component {

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {
    return(
      <BrowserRouter basename="/">
        <Switch>
          <Route path="/" exact component={App} />
          <Route path="/login" component={App} />
          <Route path="/verify/:query" component={VerifyUser} />
          <Route path="/resetpassword/:token" component={ResetPassword} />
          <Route path="/403" component={FourZeroThree} />
          <Route component={FourZeroFour} />
        </Switch>
      </BrowserRouter>
    );
  }

}

export default Router;


// WEBPACK FOOTER //
// ./src/Router.js